<template>
  <v-col>
    <validation-provider v-slot="{ errors }" :rules="rules" :name="name">
      <v-autocomplete
        :items="terminaisSelecionados"
        :error-messages="errors"
        :value="value"
        :label="label"
        :prepend-icon="icon"
        :search-input.sync="search"
        item-text="trade_name"
        item-value="cliente_id"
        @input="$emit('input', $event)"
        no-filter
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.trade_name"></v-list-item-title>
            <v-list-item-subtitle
              v-text="`CNPJ ${item.cnpj} - ${item.city} - ${item.district}`"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </validation-provider>
  </v-col>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ServicoListFiltroModalItemInputTerminal',
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      search: '',
      terminaisSelecionados: [],
    }
  },
  methods: {
    ...mapActions('contratos', ['buscarTerminaisFornecedores']),
    async getTerminalSearch(parametros) {
      if (!Object.keys(parametros).length) return
        
      try {
        await this.buscarTerminaisFornecedores()

        this.terminaisSelecionados = this.terminaisFornecedores
      } catch (e) {
        console.log(e)
        if (e.response.status === 404) {
          this.errorMessage('Página não encontrada')
        }
      }
    },
  },
  computed: {
    ...mapState('contratos', ['terminaisFornecedores']),
    ...mapState('auth', ['empresaAtual', 'user']),
  },
  watch: {
    async search(search) {
      if (search.length > 2 && search.length <= 3) {
        await this.getTerminalSearch({
          pesquisa: search,
        })
      } else if (search.length < 2) {
        this.terminaisSelecionados = []
      }
    },
  },
}
</script>
